var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DatePicker',{key:_vm.getFieldId + _vm.getValue,staticClass:"w-full",attrs:{"format":"DD MMM, YYYY","value-type":"YYYY-MM-DD","clearable":false,"placehodler":_vm.getPlaceholderVal},on:{"input":_vm.handleDatePicker},model:{value:(_vm.getValue),callback:function ($$v) {_vm.getValue=$$v},expression:"getValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }